import React, { useState, useEffect } from "react";
import AsideLeft from "./AppAdminComponents/AsideLeft";
import NavBarNotificationBar from "./AppAdminComponents/NavBarNotificationBar";
import { getuser } from "../helpers/user.helper";
import formatMoney from "../helpers/money.helper";
import formatDate from "../helpers/date.helper";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import {
  CheckSincronizedSeller,
  ListPaginate,
  deleteItem
} from "../services/seller.service";
import Swal from "sweetalert2";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Footer from "../components/Footer";

export default function VendasList() {
  let navigate = useNavigate();

  const [vendasArray, setVendas] = useState(undefined);
  const [totalPage, setTotalPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [filters, setFilters] = useState();
  const [filterLancados, setfilterLancados] = useState(false);

  useEffect(() => {
    let user = getuser();
    //Redireciona caso não esteja logado
    if (!user) {
      navigate("/login");
    }

    async function fetchData() {
      await fetchVendas(10, 1);
    }

    fetchData();
  }, [navigate]);

  async function fetchVendas(sizeRows, page, isPaginate) {
    let vendas = await ListPaginate(sizeRows, page);
    setVendas(vendas?.data.data);
    setTotalPage(vendas?.data.totalPages);
    setTotalRecords(vendas?.data.totalItems);
  }

  let state = [];

  const showItemClick = (rowData) => {
    navigate(`/venda/${rowData.id}`, { state: rowData });
  };

  const checkItem = async (rowData) => {
    Swal.fire({
      title: "<strong>Mudar status de venda?</strong>",
      icon: "question",
      html: "Deseja marcar venda como lançada no sistema? ",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim!',
      cancelButtonText: "Não",
    }).then(async (result) => {
      if (result.value) {
        let result = await CheckSincronizedSeller(rowData.id);
        if (result.status === 200) {
          let vendas = await ListPaginate(10, 1);
          setVendas(vendas?.data);
        }
      }
    });
  };

  const formatIntegrateStatus = (rowData) => {
    if (rowData) {
      return "Sim";
    } else {
      return "Não";
    }
  };

  const setOnlyPendentes = async (value) => {
    setfilterLancados(value);
    let vendas = await ListPaginate(10, 1, true);
    setVendas(vendas?.data);
  };

  const optionButtons = (rowData, column) => {
    return (
      <div>
        <button
          onClick={() => showItemClick(rowData)}
          title="Visualizar item"
          type="button"
          className="btn btn-icon btn-danger btn-sm"
        >
          <i className="fa fa-search"></i>
        </button>
        {getuser().type === "A" && (
          <>
            <button
              onClick={() => checkItem(rowData)}
              title="Marcar como lançado no sistema"
              type="button"
              className="btn btn-icon btn-info btn-sm"
            >
              <i className="fa fa-check"></i>
            </button>
            <button
              onClick={() => handleDeleteItem(rowData)}
              title="Apagar item"
              type="button"
              className="btn btn-icon btn-danger btn-sm"
            >
              <i className="fa fa-trash"></i>
            </button>
          </>
        )}
      </div>
    );
  };

  let renderLoad = () => {
    return (
      <div className="table-footer text-center">
        <Loader
          type="ThreeDots"
          color="#343A40"
          height={100}
          width={100}
          visible={true}
        />
      </div>
    );
  };

  const onPage = async (event) => {
    setFirst(event.first);
    let customers = await ListPaginate(event.rows, event.page + 1);
    setVendas(customers?.data.data);
  };

  const onFilter = async (event) => {
    if (Object.keys(event.filters).length === 0) {
      await fetchVendas(10, 1);
    } else {
      const { cod_revendedor, codCliente } = event.filters;

      if (cod_revendedor && cod_revendedor.value.length === 2) {
        let vendas = await ListPaginate(10, 1, cod_revendedor.value);
        setVendas(vendas?.data.data);
      }

      if (codCliente && codCliente.value.length === 6) {
        let vendas = await ListPaginate(10, 1, undefined, codCliente.value);
        setVendas(vendas?.data.data);
      }
    }
    setFilters(event.filters);
  };

  const handleDeleteItem = async (item) => {
    Swal.fire({
      title: "<strong>Apagar venda</strong>",
      icon: "question",
      html: "Deseja remover venda? ",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim!',
      cancelButtonText: "Não",
    }).then(async (result) => {
      if (result.value) {
        await deleteItem(item.id);
      }
    });
  };

  return (
    <>
      <div className="wrapper">
        {/* Navbar */}
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
          <NavBarNotificationBar />
        </nav>
        <AsideLeft option="vendas" />
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0 text-dark">
                    {getuser().type === "C"
                      ? "Minhas Compras"
                      : "Minhas Vendas"}
                  </h1>
                </div>
              </div>
            </div>
          </div>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                {/* Left col */}
                <section className="col-lg-12 connectedSortable">
                  {/* Custom tabs (Charts with tabs)*/}
                  <div className="card">
                    <div className="card-header">
                      <div className="card-tools">
                        <ul className="nav nav-pills ml-auto">
                          {/* <div className="col-8">
                            <div className="form-group">
                              Exibir somente pendentes de lançamento?
                              <select
                                value={filterLancados}
                                onChange={(e) => setOnlyPendentes(e.target.value)}
                                className="form-control"
                              >
                                <option value="">Selecione uma opção</option>
                                <option value="S">Sim</option>
                                <option value="N">Não</option>
                              </select>
                            </div>
                          </div> */}
                          <li className="nav-item">
                            <a
                              className="nav-link active"
                              href="/venda/nova"
                              data-toggle="tab"
                            >
                              {getuser().type === "C"
                                ? "Nova Compra"
                                : "Nova Venda"}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="card-body">
                      {!vendasArray ? (
                        renderLoad()
                      ) : (
                        <div className="tab-content p-0">
                          <DataTable
                            value={vendasArray}
                            style={{ marginBottom: 50 }}
                            paginator
                            rows={10}
                            lazy={true}
                            first={first}
                            onPage={(event) => onPage(event)}
                            onFilter={onFilter}
                            filters={filters}
                            totalRecords={totalRecords}
                            rowsPerPageOptions={[10, 20, 50]}
                            className="p-datatable-customers"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
                            emptyMessage="Você Ainda não realizou vendas"
                          >
                            <Column field="id" header="Código" />
                            <Column
                              field={(row) => formatDate(row.dataImportacao)}
                              header="Data"
                            />
                            <Column field="cliente" header="Cliente" />
                            <Column
                              field="codCliente"
                              header="Cod. Cliente"
                              filter={true}
                            />
                            <Column
                              field={(row) => formatMoney(row.total)}
                              header="Valor"
                            />
                            <Column
                              field={(row) => formatMoney(row.desconto)}
                              header="Desconto"
                            />
                            <Column
                              field={(row) =>
                                formatMoney(row.total - row.desconto)
                              }
                              header="Total"
                            />
                            <Column field="qtdItens" header="Qtd. Itens" />

                            <Column field="usuario" header="Usuário" />
                            <Column
                              field="cod_revendedor"
                              header="Cod. Rev"
                              filter={true}
                            />
                            <Column
                              key="lancado"
                              field={(row) =>
                                formatIntegrateStatus(row.integrate)
                              }
                              header="Lançado no Sistema"
                            />

                            <Column
                              key="123"
                              body={optionButtons}
                              bodyStyle={{
                                textAlign: "center",
                                overflow: "hidden",
                              }}
                            />
                          </DataTable>
                        </div>
                      )}
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </section>
        </div>

         <Footer />
        <aside className="control-sidebar control-sidebar-dark"></aside>
      </div>
    </>
  );
}
